import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Menu(theme: Theme) {
  return {
    MuiPopper: {
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.z8,
          borderRadius: 5,
        },
      },
    },
  };
}
